import HallFileList from "./hall-file-list";


const HallAction = {
  UploadDownload: HallFileList,

}


export default HallAction;